import React from 'react';

import { createRoot } from 'react-dom/client';

// eslint-disable-next-line import/no-unassigned-import
import './assets/fonts/fonts.css';

import App from './App';
import { configAnalytics } from './app/services/analytics.service';
import { configTelemetry } from './app/services/telemetry.service';
import reportWebVitals from './reportWebVitals';

configAnalytics();
configTelemetry();

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
